import * as React from 'react';

// import containers to be initialized in this component
import LiveScore from '../../containers/LiveScore';
import StatsRanking from '../../containers/StatsRanking';
import PlayerProfiles from '../../containers/PlayerProfiles';

import('./MatchListStyles.scss')   



const MatchListPresentation = (props:any) => {
    return (
        <div className={"matchGroupsContainer matchList " + isQuickBettingOn(props.quickBetsState)}>
            {props.timings.map((timing:any = {}, index: number ) =>
            <div className={"matchGroupContainer " +  isMatchGroupActive(props.activeChannelId, (index+1))}
                 key={"matchGroup_"+timing.id}>
                <div style={{height: '60%', width: '100%'}}
                     className={`${isHidden(timing.id !== props.activeChannelId)}`}>
                    <PlayerProfiles channelId={timing.id}>
                        <StatsRanking active={timing.id === props.activeChannelId}
                                 key={"ranking_"+timing.id}
                                 id={timing.id-1}
                                 rankingMatchlist={true}
                                 quickBetsState={props.quickBetsState}/>
                    </ PlayerProfiles>
                </div>
                <div className="matchGroupLivescore">
                    <LiveScore key={`livescore-${timing.id}`}
                               channelId={ timing.id }
                               currentPhase={props.phase}/>
                </div>
            </div>
                )}
        </div>
    )
};


// set class if quick betting is activated in gui
const isQuickBettingOn = (expanded:boolean) => {
    return expanded === true ? 'quickBettingActive' : '';
};

// set class if match is in currently selected channel
const isMatchGroupActive = (activeChannelId:number, index:number) => {
    return activeChannelId === index ? 'matchGroupActive' : ''
};

const isHidden = (state:boolean) => state ? 'hidden' : '';

export default MatchListPresentation;
